import "babel-polyfill";
import Placeholder from "./util/placeholder";
import Timer from "./util/timer";
import Onlynumber from "./util/onlynumber";

window.placeHolder1 = new Placeholder({
    el:"#placeHolder1"
});

window.placeHolder2 = new Placeholder({
    el:"#placeHolder2"
});

window.phoneNumber = new Timer({
    el:"#timer1",
    minutes:5,
    start:false
});

const onlynumber1 = new Onlynumber({
    el:"[data-input='check']"
});


window.placeHolder3 = new Placeholder({
    el:"#placeHolder3"
});

window.placeHolder4 = new Placeholder({
    el:"#placeHolder4"
});

const onlynumber2 = new Onlynumber({
    el:"[data-input='check']"
});

window.valueCheck = ()=>{
    if (!$(".coupon_number").find("input").attr("value")) {
        $(".coupon_number").removeClass("off");
    } else {
        $(".coupon_number").addClass("off");
    }
}

window.layer1 = '';
const pageMain = {
    layer() {
        window.layer1 = new nc.promokit.Layer({
            'el': '#layer-coupon',
            fade: true,
            esc: true,
            dim: true,
            dimClickClose: true,
            name: 'layer-coupon-box'
        });

        $(document).on('click', '.layer-coupon .layerClose', ()=>{
            layer1.close();
        });
        layer1.on('layeropenstart', function(){
            if( !window.couponNumber ){
                window.couponNumber = new Timer({
                    el: "#timer2",
                    minutes: 5,
                    start: false
                });
            }
        });
        layer1.on('layercloseend', function(){
            $('.layer-coupon .input_box').val('');
            placeHolder3.input();
            placeHolder4.input();
            window.couponNumber.cleartimer(false);
        });
    }
};


$(document).ready(function () {
    $('body').TopBtn();
    $('.toggle-caution').Folding({open: true});

    pageMain.layer();
});





// WEBPACK FOOTER //
// ./src/js/promise.js